import { render, staticRenderFns } from "./MessageNotice.vue?vue&type=template&id=6478401b&scoped=true&"
import script from "./MessageNotice.vue?vue&type=script&lang=js&"
export * from "./MessageNotice.vue?vue&type=script&lang=js&"
import style0 from "./MessageNotice.vue?vue&type=style&index=0&id=6478401b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6478401b",
  null
  
)

export default component.exports